import React from 'react';

function Footer() {
	return (
		<footer>
			Made by
			<a
				href='https://github.com/nashitshayan'
				target='_blank'
				rel='noreferrer'>
				{' '}
				Nashit Shayan Khan{' '}
			</a>
			. Click
			<a
				href='https://github.com/nashitshayan/quizzical'
				target='_blank'
				rel='noreferrer'>
				{' '}
				here{' '}
			</a>
			to see the code.
		</footer>
	);
}

export default Footer;
